import React from 'react';

import { Box, Typography } from '@mui/material';

import { CommonComponentProps, ImageObject } from '../pages/types';
import EditableMarkdownText from './editable-markdown-text';

interface PageHeaderProps extends CommonComponentProps {
  title?: string;
  subtitle?: string;
  backgroundImage?: ImageObject;
  height?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  id,
  title = '',
  subtitle: paragraph = '',
  backgroundImage,
  height,
  sx,
  isEditable,
  onPropsChange,
  onImageUpload,
}) => {
  const handleTextChange = (key: keyof PageHeaderProps, value: string) => {
    if (onPropsChange) {
      onPropsChange({ [key]: value });
    }
  };

  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (
      isEditable &&
      onImageUpload &&
      onPropsChange &&
      e.target === e.currentTarget
    ) {
      onImageUpload((url) => {
        onPropsChange({
          backgroundImage: {
            ...(backgroundImage || { title: '', altText: '' }),
            url: url,
          },
        });
      });
    }
  };

  if (backgroundImage) {
    if (backgroundImage.url)
      backgroundImage.url = backgroundImage.url.replace(/ /g, '%20');
  }

  return (
    <Box
      id={id}
      onClick={handleBackgroundClick}
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height ? height : '30vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        cursor: isEditable ? 'pointer' : 'default',
        ...(backgroundImage && {
          backgroundImage: `url(${backgroundImage.url})`,
        }),
        ...sx,
      }}
    >
      <EditableMarkdownText
        content={title}
        onSave={(val) => handleTextChange('title', val)}
        isEditable={!!isEditable}
        component={Typography}
        typographyVariant="h1"
        sx={{ paddingBottom: 2, cursor: isEditable ? 'text' : 'inherit' }}
      />
      <EditableMarkdownText
        content={paragraph}
        onSave={(val) => handleTextChange('subtitle', val)}
        isEditable={!!isEditable}
        component={Typography}
        typographyVariant="h2"
        sx={{ cursor: isEditable ? 'text' : 'inherit' }}
      />
    </Box>
  );
};
export default PageHeader;
